import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/simple-interest-calculator',
  component: () => import('../../routes/SimpleInterestCalculator.svelte'),
  card: {
    id: 'simple-interest-calculator',
    title: 'Simple Interest Calculator',
    description: 'Calculate simple interest on loans or investments using the SI = P × r × t formula.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/simple-interest-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Simple Interest Calculator – Free SI = P × r × t Calculator',
    description: 'Free simple interest calculator. Calculate interest earned or owed using the simple interest formula SI = P × r × t. View year-by-year breakdown and total amount.',
  },
};

export default meta;
